import { Program } from './../inModels/program';
import { BusinessCategory } from "../inModels/business-category";
import { Team } from "../inModels/Team";

export interface User {
    Id;
    UserName;
    Email;
    PhoneNumber;
    FirstName;
    LastName;
    DateCreatedUtc;
    Role;
    Gender;
    GenderId;
	ProfilePictureId;
	DateOfBirth;
    PhoneNumberConfirmed;
    EmailConfirmed;
    Groups : GroupsDto[];
    BusinessCategories: BusinessCategory[];
    ClientId;
    Client;
    Verified;
    ProfileType;
	Team: Team;
    ProgrammeName;
    ProgrammeId;
    AssignedCoachId;
}

export class CreateUserModel {
    UserName: string;
    Email: string;
    FirstName: string;
    LastName: string;
    PhoneNumber: string;
    ProfilePictureId;
    DateOfBirth;
    Password: string;
    ConfirmPassword: string;
    Groups : number[];
    BusinessCategories: number[];
	Client: number;
    ProgrammeName: string;
    ProgrammeId: number;
    AssignedCoachId: string;
    constructor() {
	    this.Groups = [];
    }
    Verified: boolean;
}

export class EditUserModel {
    Id: string;
    Email: string;
    PhoneNumber: string;
    FirstName: string;
    LastName: string;
    UserName: string;
    Role: string;
    Gender: boolean;
    GenderId: boolean;
    ProfilePictureId: string;
    DateOfBirth: Date;
    PhoneNumberConfirmed: boolean;
    EmailConfirmed: boolean;
    Groups : number[];
    BusinessCategories: number[];
    Client: number;
    Verified: boolean;
    ProfileType: number;
    ProgrammeName: string;
    ProgrammeId: number;
    AssignedCoachId: string;
    constructor(user: User) {
        this.Id = user.Id;
        this.Email = user.Email;
        this.PhoneNumber = user.PhoneNumber;
        this.FirstName = user.FirstName;
        this.LastName = user.LastName;
        this.UserName = user.UserName;
        this.Role = user.Role;
        this.Gender = user.Gender;
        this.GenderId = user.GenderId;
        this.ProfilePictureId = user.ProfilePictureId;
        this.DateOfBirth = new Date(user.DateOfBirth);
        this.PhoneNumberConfirmed = user.PhoneNumberConfirmed;
		this.EmailConfirmed = user.EmailConfirmed;
		this.Groups = user && user.Groups.map(x => x.Id);
		this.Client = user && user.ClientId;
        this.BusinessCategories = user && user.BusinessCategories.map(x => x.Id);
        this.Verified = user && user.Verified;
        this.ProfileType = user && user.ProfileType;
        this.ProgrammeId = user && user.ProgrammeId;
        this.ProgrammeName = user && user.ProgrammeName;
        this.AssignedCoachId = user && user.AssignedCoachId;
    }
}

export class GroupsDto {
	public Id: number;
	public Name: string;
}



// WEBPACK FOOTER //
// ./src/app/models/outModels/User.ts